import React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.426"
    height="27.915"
    viewBox="0 0 24.426 27.915"
    className={className}
  >
    <g opacity="0.5">
      <g transform="translate(0)">
        <g>
          <path
            d="M35.936,19.868V18.123a8.723,8.723,0,0,0-17.447,0v1.745A3.487,3.487,0,0,0,15,23.357v6.979a6.973,6.973,0,0,0,6.979,6.979H32.447a6.973,6.973,0,0,0,6.979-6.979V23.357A3.466,3.466,0,0,0,35.936,19.868Zm-6.979,10v2.214a1.745,1.745,0,0,1-3.489,0V29.833a3.461,3.461,0,1,1,3.489.034Zm3.154-10H22.281a5.041,5.041,0,0,1-.336-1.745,5.234,5.234,0,1,1,10.468,0A4.451,4.451,0,0,1,32.111,19.868Z"
            transform="translate(-15 -9.4)"
            fill="#a8a8a8"
            fillRule="evenodd"
          />
        </g>
      </g>
    </g>
  </svg>
);
